import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/components/ui/alert-dialog";
import type { ReferencedRemoval } from "../settings.patch.utils";

export function ReferencedRemovalConfirmation({
  removals,
  open,
  onOpenChange,
  onConfirm,
}: {
  removals: ReferencedRemoval[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Ta bort använt innehåll?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                Sparandet tar bort val och bossuppställningar som använder
                innehållet:
              </p>
              <ul className="list-disc space-y-2 pl-5">
                {removals.map((removal) =>
                  removal.kind === "raid" ? (
                    <li key={`raid:${removal.name}`}>
                      <span className="font-medium text-foreground">
                        Raid: {removal.name}
                      </span>
                      {" — "}
                      {removal.raidDayCount} raiddag
                      {removal.raidDayCount === 1 ? "" : "ar"},{" "}
                      {removal.bossViewCount} bossvy
                      {removal.bossViewCount === 1 ? "" : "er"}
                    </li>
                  ) : (
                    <li key={`boss:${removal.raidName}:${removal.name}`}>
                      <span className="font-medium text-foreground">
                        Boss: {removal.raidName} / {removal.name}
                      </span>
                      {" — "}
                      {removal.bossViewCount} bossvy
                      {removal.bossViewCount === 1 ? "" : "er"},{" "}
                      {removal.assignmentCount} tilldelning
                      {removal.assignmentCount === 1 ? "" : "ar"}
                    </li>
                  ),
                )}
              </ul>
              <p>Åtgärden går inte att ångra.</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Avbryt</AlertDialogCancel>
          <AlertDialogAction variant="destructive" onClick={onConfirm}>
            Ta bort och spara
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function PatchDeleteConfirmation({
  open,
  pending,
  onOpenChange,
  onConfirm,
}: {
  open: boolean;
  pending: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Ta bort patchen?</AlertDialogTitle>
          <AlertDialogDescription>
            Patchen används inte av någon raiddag. Åtgärden går inte att ångra.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Avbryt</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={pending}
            onClick={onConfirm}
          >
            Ta bort
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
